import { UpdateUserMutation } from "src/api/User";
import { apiClient } from "src/stores/Api";
import { useStore } from "src/stores/Store";
import {
  EventType,
  SettingType,
  updateUserVariables,
} from "types/code-generator";

export function AdyenChangeAlert() {
  const store = useStore();
  const showAlert = store.organization.events.find(
    (e) =>
      e.type === EventType.ProcessorUse &&
      e.value === "Adyen" &&
      !store.user.settings.find((s) => s.type === SettingType.AdyenAlert) &&
      store.organization.balanceAccounts.length > 0 &&
      !store.organization.stripeAlert
  );

  async function dismissAlert() {
    const variables: updateUserVariables = {
      data: {
        settings: {
          create: [
            {
              type: SettingType.AdyenAlert,
              value: "dismissed",
            },
          ],
        },
      },
      where: {
        id: store.user.id,
      },
    };

    await apiClient(UpdateUserMutation, { variables });
    store.updateUser();
  }

  if (!showAlert) {
    return null;
  }

  return (
    <div className="mb-4 block rounded-lg bg-paleSuccess px-6 py-4 pb-2 text-dark">
      <div className="mb-4 flex items-center gap-2">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-success">
          <i className="far fa-face-smile text-xl text-white" />
        </div>
        <div className="flex-1 font-bold">
          New payment processor and financial reports are now live
        </div>
      </div>

      <p>
        Big new updates are now available for your use. The updates can be found
        by visiting <strong>Menu &gt; Settings & Reports &gt; Financial</strong>
      </p>

      <p>Thank you for your cooperation in making this switch.</p>

      <p>
        <strong>We hope you enjoy your new live-action reporting.</strong>
      </p>

      <hr className="-mx-6 border-success border-opacity-50" />

      <button
        type="button"
        className="block w-full pb-2 font-bold text-success"
        onClick={dismissAlert}
      >
        <i className="far fa-xmark" /> Dismiss alert
      </button>
    </div>
  );
}
